export const reatiler = [
    {
        'Value': '02',
        'Text': 'Gürmar Market'
    },
    {
        'Value': '01',
        'Text': 'Onur Market'
    },
    {
        'Value': '03',
        'Text': 'Sarıyer Market'
    },
    {
        'Value': '04',
        'Text': 'Biçen'
    },
    {
        'Value': '06',
        'Text': 'Migros'
    }
]
